export enum Aggregate
{
    Count,
    Sum,
    Average,
    Min,
    Max
}
